import PropTypes from 'prop-types';
import React from 'react';
import b from 'b_';
import './Dashboard.css';

const block = b.lock('Dashboard');

export default function WidgetWrapper({ size, children, ...props }) {
    return <div
        className={block('Item', { size })}
        {...props}
    >
        <div className={block('ItemContent')}>
            {children}
        </div>
    </div>;
}

WidgetWrapper.propTypes = {
    size: PropTypes.number.isRequired,
};
